import { Mic } from 'lucide-react';
import { cn } from '@/utils/merge';
import { useSpeechDigits } from '@/utils/useSpeechDigits';

// The microphone inside «Αναζήτηση Πελάτη»: tap, say the phone number, and
// its digits fill the search. Tap again to stop early.
export const PhoneMicButton = ({ onDigits }) => {
	const { listening, start, stop } = useSpeechDigits(onDigits);
	return (
		<button
			type='button'
			onClick={listening ? stop : start}
			aria-label={listening ? 'Σταμάτημα φωνητικής εισαγωγής' : 'Πείτε το τηλέφωνο'}
			title={listening ? 'Ακούω… (πατήστε για σταμάτημα)' : 'Πείτε το τηλέφωνο'}
			className={cn(
				'flex h-8 w-8 cursor-pointer items-center justify-center rounded-full transition-colors',
				listening ? 'animate-pulse bg-red-500 text-white' : 'text-[#0f9b9d] hover:bg-slate-100',
			)}
		>
			<Mic size={20} />
		</button>
	);
};
